import { auth } from '../firebase/config';

const BACKEND_BASE_URL =
  import.meta.env.VITE_BACKEND_BASE_URL ||
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  'https://mintleaf-foglalasok-4-ai-copy.onrender.com';

const getAuthToken = async (): Promise<string> => {
  const sessionToken = window.localStorage.getItem('mintleaf_api_token');
  if (sessionToken) return sessionToken;

  const user = auth.currentUser;
  if (!user) throw new Error('UNAUTHENTICATED');
  return user.getIdToken();
};

const request = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const token = await getAuthToken();
  const response = await fetch(`${BACKEND_BASE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init.headers || {}),
    },
  });

  if (!response.ok) {
    let payload: any = null;
    try {
      payload = await response.json();
    } catch {
      payload = null;
    }
    const error = new Error(payload?.message || 'USER_API_ERROR');
    (error as any).statusCode = response.status;
    throw error;
  }

  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
};

export const createUserViaApi = (payload: Record<string, any>) =>
  request<{ id: string }>('/api/users', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const listUsersViaApi = (unitScope?: string | string[]) => {
  const params = new URLSearchParams();
  if (Array.isArray(unitScope)) {
    const unitIds = Array.from(new Set(
      unitScope.map(unitId => unitId.trim()).filter(Boolean)
    ));
    if (unitIds.length > 0) params.set('unitIds', unitIds.join(','));
  } else if (unitScope) {
    params.set('unitId', unitScope);
  }
  const query = params.toString();
  return request<any[]>(`/api/users${query ? `?${query}` : ''}`);
};

export const updateUserViaApi = (userId: string, payload: Record<string, any>) =>
  request(`/api/users/${encodeURIComponent(userId)}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const deleteUserViaApi = (userId: string) =>
  request(`/api/users/${encodeURIComponent(userId)}`, {
    method: 'DELETE',
  });

export const deactivateUserViaApi = (userId: string) =>
  request(`/api/users/${encodeURIComponent(userId)}/deactivate`, {
    method: 'PATCH',
  });
